import { render, staticRenderFns } from "./EleFormColor.vue?vue&type=template&id=327859b8&"
import script from "./EleFormColor.vue?vue&type=script&lang=js&"
export * from "./EleFormColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports